import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s500};
`

export const MobileMenuUserSectionSkeleton = () => (
  <SkeletonWrapper>
    <Box width="90px" height="90px">
      <SkeletonLoader height="100%" circle />
    </Box>
    <Box
      paddingTop="s200"
      paddingBottom="s200"
      paddingRight="s500"
      paddingLeft="s500"
    >
      <SkeletonLoader width={90} />
      <SkeletonLoader width={150} />
    </Box>
  </SkeletonWrapper>
)
